import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5156c147"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Der Nutzer wurde erfolgreich angelegt. Sie können sich nun alle Informationen zu Ihrem Profil anzeigen lassen, oder über die Leiste am oberen Bildschirmrand weitere Aktionen vornehmen. ")
const _hoisted_2 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_button, {
        title: 'Nutzer anzeigen',
        onClick: _ctx.showUser
      }, null, 8, ["onClick"])
    ])
  ], 64))
}